import { message } from 'antd';
import { resetPassword } from 'api/auth';
import Layout from 'components/Layout';
import Navbar from 'components/Layout/Navbar';
import Loading from 'components/Loading';
import React, { useEffect, useState } from 'react';
import {
  Card, Col, Container, Form, Row,
} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { Navigate } from 'react-router';
import styled from 'styled-components';
import { captureException } from 'utils/errors';
import { WL_CONFIG } from 'constants';
import { Colors } from '../../assets/colors';

const Submit = styled.div`
  a {
    color: ${Colors.white} !important;
    font-weight: bold;
    font-size: 15px !important;
  }
`;

function Onboarding({ ...props }) {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({});
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState({});
  const location = useLocation();

  const { from } = props.location.state || { from: { pathname: '/console' } };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setForm({ ...form, [name]: value });
  };

  const submit = () => {
    if (!form.email) return;
    setLoading(true);
    resetPassword(form)
      .then((res) => {
        message.success('Email sent! Check your inbox!');
        setRedirect(true);
        setLoading(false);
      })
      .catch((e) => {
        captureException(e);
        setLoading(false);
      });
  };

  useEffect(() => {
    const email = location.search.split('?email=')[1];
    if (!email) {
      setRedirect(true);
    }
    setForm({ ...form, email });
  }, []);

  useEffect(() => {
    setRedirect(props.isLoggedIn);
  }, [props.isLoggedIn]);

  if (redirect) {
    return <Navigate to={from} />;
  }

  return (
    <Layout hasSidebar={false}>
      <Navbar />
      <div
        style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col xl={10} lg={12} md={9}>
              <Card className="o-hidden border-0 shadow-lg my-5">
                <Card.Body className="p-3">
                  <Row className="">
                    <Col md={12}>
                      <h3 className="h4 text-dark my-2 text-center font-weight-bold">
                        Welcome to
                        {' '}
                        { WL_CONFIG.name }
                      </h3>
                      <p className="p-0 m-0 text-center">
                        Click on the button below and we'll send a link to your
                        email,
                        <br />
                        which will take you through resetting the auto-generated
                        password.
                        <br />
                        Once you finish this process you'll be able to login to
                        your dashboard.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <div className="col-lg-12">
                      <div className="p-5">
                        <Form className="user" onSubmit={submit}>
                          <Form.Group className="row hidden">
                            <Col md={{ span: 6, offset: 3 }} className="mb-3">
                              <Form.Control
                                type="text"
                                className="form-control form-control-user"
                                placeholder="Email"
                                name="email"
                                onChange={handleChange}
                                value={form.email}
                              />
                              {error.firstnameError && (
                                <Form.Control.Feedback
                                  style={{ display: 'block' }}
                                  type="invalid"
                                >
                                  *required
                                </Form.Control.Feedback>
                              )}
                            </Col>
                          </Form.Group>

                          <Submit className="text-center">
                            <a
                              onClick={submit}
                              className="btn btn-user"
                              style={{
                                color: Colors.white,
                                background: '#04B261',
                                minWidth: 120,
                                fontWeight: 'bold',
                              }}
                            >
                              {!loading ? (
                                'Send the Link'
                              ) : (
                                <Loading nopadding />
                              )}
                            </a>
                          </Submit>
                          <br />
                        </Form>
                      </div>
                    </div>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
}

export default Onboarding;
